import * as React from "react";
import type { SVGProps } from "react";
const SvgPaidGreen = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={17}
    fill="none"
    viewBox="0 0 16 17" {...props}
  >
    <circle cx={8} cy={8.5} r={8} fill="#1A9535" />
    <path
      fill="#CDFFD9"
      d="M5.333 10.329h4.19a.35.35 0 0 0 .27-.134.5.5 0 0 0 .112-.323.5.5 0 0 0-.112-.324.35.35 0 0 0-.27-.134H6.477c-.505 0-.99-.24-1.347-.669s-.558-1.01-.558-1.616.201-1.188.558-1.617c.358-.428.842-.669 1.347-.669h.762v-.914h1.524v.914h1.905v1.829h-4.19a.35.35 0 0 0-.27.133.5.5 0 0 0-.112.324c0 .121.04.237.112.323a.35.35 0 0 0 .27.134h3.047c.505 0 .99.24 1.347.67.357.428.558 1.01.558 1.616s-.201 1.187-.558 1.616c-.357.428-.842.67-1.347.67h-.762v.914H7.238v-.915H5.333z"
    />
  </svg>
);
export default SvgPaidGreen;
